import React from 'react';
import Hero from '../components/Hero';
import ShopByCategory from '../components/ShopByCategory';
import CategoryTabs from '../components/CatogoryProduct';
import ProductList from '../components/ProductList';

const Home = () => {
  return (
    <div className="container-fluid">
      <Hero />
      <ShopByCategory />
      <CategoryTabs />
      <ProductList />
    </div>
  );
};

export default Home;
